/*
 * Lumos PDP gift row (snippets/lumos-pdp-gift.liquid).
 *
 * Add puts the gift variant in the cart; a Shopify automatic discount makes
 * it free while the page product is in the cart, so this script only adds
 * the item. Like the cart drawer add-ons (assets/lumos-cart-addons.js) the
 * write takes the theme cart lock (window.LumosCartOperations) and ends with
 * the theme's cart:refresh, which re-renders the cart without opening the
 * drawer. Before adding, the cart is read again: while it already holds one
 * gift per page product (at least one), nothing more is added.
 *
 * While the gift is in the cart it is also listed in Your order
 * ([data-lumos-pdp-order-list], rebuilt by assets/lumos-pdp.js) with the
 * same row markup at its free price, so the total stays the page product's.
 * Its remove button (data-lumos-pdp-gift-remove, not lumos-pdp.js's
 * data-lumos-pdp-order-remove) and pressing Added again both take every gift
 * line out of the cart in one /cart/update.js write under the same lock.
 * The cart is read again after the theme's own cart writes
 * (theme:loading:end, product:added, cart:refresh), for example a drawer remove.
 *
 * data-ends-at (Unix seconds) drives a countdown; at zero the row and its
 * Your order line are hidden (the discount ends at the same time). data-stock
 * is the gift's tracked stock; the row shows it less this cart's gifts.
 */
(function (global) {
  'use strict';

  if (global.LumosPdpGift) return;
  var doc = global.document;
  var ROOT = '[data-lumos-pdp-gift]';

  function route(name, fallback) {
    var routes = global.routes || {};
    return routes[name] || fallback;
  }

  function readCart() {
    return fetch(route('cartUrl', '/cart') + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('cart ' + response.status);
      return response.json();
    });
  }

  function counts(root, cart) {
    var giftId = Number(root.getAttribute('data-variant-id'));
    var productId = Number(root.getAttribute('data-trigger-product-id'));
    var result = { gift: 0, product: 0 };
    ((cart && cart.items) || []).forEach(function (item) {
      var quantity = Number(item.quantity) || 0;
      if (Number(item.variant_id) === giftId) result.gift += quantity;
      if (Number(item.product_id) === productId) result.product += quantity;
    });
    return result;
  }

  function covered(count) {
    return count.gift > 0 && count.gift >= Math.max(1, count.product);
  }

  function orderLine(root) {
    var item = doc.createElement('li');
    item.className = 'lumos-pdp__order-item';
    item.setAttribute('data-lumos-pdp-gift-line', '');
    var thumb = doc.createElement('span');
    thumb.className = 'lumos-pdp__order-thumb';
    var src = root.getAttribute('data-order-image');
    if (src) {
      var image = doc.createElement('img');
      image.src = src;
      image.alt = '';
      image.width = 64;
      image.height = 64;
      image.loading = 'lazy';
      thumb.appendChild(image);
    }
    var text = doc.createElement('span');
    text.className = 'lumos-pdp__order-text';
    var title = doc.createElement('span');
    title.className = 'lumos-pdp__order-name';
    title.textContent = root.getAttribute('data-order-title') || '';
    var sub = doc.createElement('span');
    sub.className = 'lumos-pdp__order-sub';
    sub.textContent = root.getAttribute('data-order-sub') || '';
    text.appendChild(title);
    text.appendChild(sub);
    var prices = doc.createElement('span');
    prices.className = 'lumos-pdp__order-prices';
    var now = doc.createElement('span');
    now.className = 'lumos-pdp__order-price';
    now.textContent = root.getAttribute('data-order-price') || '';
    prices.appendChild(now);
    var compare = root.getAttribute('data-order-compare');
    if (compare) {
      var was = doc.createElement('s');
      was.textContent = compare;
      prices.appendChild(was);
    }
    // Same remove button as a setup row; lumos-pdp.js ignores it (no data-lumos-pdp-order-remove).
    var remove = doc.createElement('button');
    remove.type = 'button';
    remove.className = 'lumos-pdp__order-remove';
    remove.setAttribute('data-lumos-pdp-gift-remove', root.getAttribute('data-variant-id') || '');
    var removeLabel = (root.getAttribute('data-remove-label') || 'Remove') + ' ' + title.textContent;
    remove.setAttribute('aria-label', removeLabel);
    remove.title = removeLabel;
    remove.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12"/><path d="M18 6L6 18"/></svg>';
    item.appendChild(thumb);
    item.appendChild(text);
    item.appendChild(prices);
    item.appendChild(remove);
    return item;
  }

  // Your order is cleared and rebuilt on every option change; the observer puts the gift line back.
  function placeOrderLine(root) {
    var inCart = root.getAttribute('data-lumos-pdp-gift-in-cart') === 'true';
    var scope = root.closest('[data-lumos-pdp-root]') || doc;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-lumos-pdp-order-list]'), function (list) {
      var line = list.querySelector('[data-lumos-pdp-gift-line]');
      if (inCart && !line) list.appendChild(orderLine(root));
      else if (!inCart && line) line.parentNode.removeChild(line);
      if (!list.hasAttribute('data-lumos-pdp-gift-observed') && global.MutationObserver) {
        list.setAttribute('data-lumos-pdp-gift-observed', '');
        new global.MutationObserver(function () { placeOrderLine(root); }).observe(list, { childList: true });
      }
    });
  }

  function render(root, count) {
    var inCart = count.gift > 0 && !root.hasAttribute('data-lumos-pdp-gift-over');
    root.setAttribute('data-lumos-pdp-gift-in-cart', inCart ? 'true' : 'false');
    placeOrderLine(root);
    var stock = root.querySelector('[data-lumos-pdp-gift-stock]');
    if (stock) {
      var left = Math.max(0, Number(root.getAttribute('data-stock')) - count.gift);
      stock.hidden = left <= 0;
      stock.textContent = (root.getAttribute('data-stock-label') || '[count] left').replace('[count]', left);
    }
    var button = root.querySelector('[data-lumos-pdp-gift-add]');
    if (!button || button.hasAttribute('data-sold-out')) return;
    var added = covered(count);
    var label = button.querySelector('[data-lumos-pdp-gift-label]');
    button.classList.toggle('is-added', added);
    button.setAttribute('aria-pressed', added ? 'true' : 'false');
    if (label) label.textContent = button.getAttribute(added ? 'data-added-label' : 'data-add-label') || '';
    if (added) button.title = (root.getAttribute('data-remove-label') || 'Remove') + ' ' + (root.getAttribute('data-order-title') || '');
    else button.removeAttribute('title');
  }

  function message(root, text) {
    var node = root.querySelector('[data-lumos-pdp-gift-error]');
    if (!node) return;
    node.textContent = text || '';
    node.hidden = !text;
  }

  function sync(root) {
    return readCart().then(function (cart) {
      render(root, counts(root, cart));
    }).catch(function () { /* keep the current state */ });
  }

  function syncAll() {
    Array.prototype.forEach.call(doc.querySelectorAll(ROOT), sync);
  }

  var syncTimer = null;
  function syncSoon() {
    global.clearTimeout(syncTimer);
    syncTimer = global.setTimeout(syncAll, 600);
  }

  function add(root, button) {
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
    var operations = global.LumosCartOperations;
    var operation = null;
    var busy = false;
    button.setAttribute('aria-busy', 'true');
    message(root, '');

    readCart().then(function (cart) {
      var count = counts(root, cart);
      if (covered(count)) {
        render(root, count);
        return null;
      }
      if (operations && typeof operations.beginCartMutation === 'function') {
        operation = operations.beginCartMutation({ element: root }, { kind: 'addon', item: 'lumos-pdp-gift' });
        if (!operation) {
          busy = true;
          throw new Error('busy');
        }
      }
      doc.dispatchEvent(new global.CustomEvent('theme:loading:start'));
      return fetch(route('cartAddUrl', '/cart/add') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: Number(root.getAttribute('data-variant-id')), quantity: 1 }] })
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (content) {
          if (!response.ok) throw new Error((content && (content.description || content.message)) || 'add');
          if (operation) operations.finishCartOperation(operation);
          operation = null;
          render(root, { gift: count.gift + 1, product: count.product });
          doc.documentElement.dispatchEvent(new global.CustomEvent('cart:refresh', { bubbles: true }));
          return content;
        });
      }).finally(function () {
        doc.dispatchEvent(new global.CustomEvent('theme:loading:end'));
      });
    }).catch(function () {
      if (operation && typeof operations.failCartOperation === 'function') operations.failCartOperation(operation);
      operation = null;
      message(root, button.getAttribute(busy ? 'data-busy-label' : 'data-error-label'));
    }).then(function () {
      button.removeAttribute('aria-busy');
    });
  }

  // Added pressed again, or the Your order remove button: every gift line leaves the cart.
  function removeGift(root, trigger) {
    if (trigger.getAttribute('aria-busy') === 'true') return;
    var operations = global.LumosCartOperations;
    var operation = null;
    var busy = false;
    var button = root.querySelector('[data-lumos-pdp-gift-add]');
    trigger.setAttribute('aria-busy', 'true');
    message(root, '');

    readCart().then(function (cart) {
      var count = counts(root, cart);
      var giftId = Number(root.getAttribute('data-variant-id'));
      var updates = {};
      ((cart && cart.items) || []).forEach(function (item) {
        if (Number(item.variant_id) === giftId) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) {
        render(root, { gift: 0, product: count.product });
        return null;
      }
      if (operations && typeof operations.beginCartMutation === 'function') {
        operation = operations.beginCartMutation({ element: root }, { kind: 'addon', item: 'lumos-pdp-gift' });
        if (!operation) {
          busy = true;
          throw new Error('busy');
        }
      }
      doc.dispatchEvent(new global.CustomEvent('theme:loading:start'));
      return fetch(route('cartUpdateUrl', '/cart/update') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: updates })
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (content) {
          if (!response.ok) throw new Error((content && (content.description || content.message)) || 'remove');
          if (operation) operations.finishCartOperation(operation);
          operation = null;
          render(root, { gift: 0, product: count.product });
          doc.documentElement.dispatchEvent(new global.CustomEvent('cart:refresh', { bubbles: true }));
          return content;
        });
      }).finally(function () {
        doc.dispatchEvent(new global.CustomEvent('theme:loading:end'));
      });
    }).catch(function () {
      if (operation && typeof operations.failCartOperation === 'function') operations.failCartOperation(operation);
      operation = null;
      if (button) message(root, button.getAttribute(busy ? 'data-busy-label' : 'data-error-label'));
    }).then(function () {
      trigger.removeAttribute('aria-busy');
    });
  }

  function pad(value) {
    return (value < 10 ? '0' : '') + value;
  }

  function formatLeft(ms, daysLabel) {
    var seconds = Math.max(0, Math.floor(ms / 1000));
    var days = Math.floor(seconds / 86400);
    seconds -= days * 86400;
    var hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;
    var minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;
    return (days > 0 ? days + daysLabel + ' ' : '') + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  // At the offer end the discount ends too: the row and its Your order line go away.
  function startCountdown(root) {
    var endsAt = Number(root.getAttribute('data-ends-at')) * 1000;
    if (!endsAt) return;
    var node = root.querySelector('[data-lumos-pdp-gift-time]');
    var daysLabel = root.getAttribute('data-days-label') || 'd';
    var timer = null;
    function tick() {
      var left = endsAt - Date.now();
      if (left <= 0) {
        global.clearInterval(timer);
        root.setAttribute('data-lumos-pdp-gift-over', '');
        root.setAttribute('data-lumos-pdp-gift-in-cart', 'false');
        root.hidden = true;
        placeOrderLine(root);
        return;
      }
      if (node) node.textContent = formatLeft(left, daysLabel);
    }
    tick();
    timer = global.setInterval(tick, 1000);
  }

  function init(root) {
    if (!root || root.hasAttribute('data-lumos-pdp-gift-ready')) return;
    root.setAttribute('data-lumos-pdp-gift-ready', '');
    var button = root.querySelector('[data-lumos-pdp-gift-add]');
    if (button && button.disabled) button.setAttribute('data-sold-out', '');
    startCountdown(root);
    sync(root);
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || doc).querySelectorAll(ROOT), init);
  }

  doc.addEventListener('click', function (event) {
    var target = event.target && event.target.closest
      ? event.target.closest(ROOT + ' [data-lumos-pdp-gift-add], [data-lumos-pdp-gift-remove]')
      : null;
    if (!target) return;
    event.preventDefault();
    if (target.hasAttribute('data-lumos-pdp-gift-remove')) {
      var scope = target.closest('[data-lumos-pdp-root]') || doc;
      var owner = scope.querySelector(ROOT + '[data-variant-id="' + target.getAttribute('data-lumos-pdp-gift-remove') + '"]') || scope.querySelector(ROOT);
      if (owner) removeGift(owner, target);
      return;
    }
    if (target.classList.contains('is-added')) removeGift(target.closest(ROOT), target);
    else add(target.closest(ROOT), target);
  });

  // The cart can change elsewhere (purchase bar, drawer, another tab): read it again then.
  doc.addEventListener('product:added', syncSoon);
  doc.addEventListener('cart:refresh', syncSoon);
  doc.addEventListener('theme:loading:end', syncSoon);
  global.addEventListener('pageshow', function (event) { if (event.persisted) syncAll(); });
  doc.addEventListener('shopify:section:load', function (event) { initAll(event.target); });

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  global.LumosPdpGift = { version: 1, sync: syncAll };
}(window));
